import { addYears, format, isDate, parse } from "date-fns";

function parseDateString(originalValue) {
  const parsedDate = isDate(originalValue)
    ? originalValue
    : parse(originalValue, "dd/MM/yyyy", new Date());

  return parsedDate;
}

export function addToYears(originalDate = new Date(), numberOfYears = 1) {
  const result = addYears(originalDate, numberOfYears);

  return result;
}

export function formatDate(originalDate, formateStyle = "dd/MM/yyyy") {
  const formattedData = format(originalDate, formateStyle);

  return formattedData;
}
